import { render, staticRenderFns } from "./ChartIcon.vue?vue&type=template&id=90d3909a"
import script from "./ChartIcon.vue?vue&type=script&lang=js"
export * from "./ChartIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports